"use client";

import { BuildAgentForFreeButton } from "~/components/marketplace/build-agent-for-free-button";
import { BookDemoCTA, PrimaryCTA } from "~/components/siteglue/siteglue-cta";
import { motion } from "framer-motion";
import { getMarketingChrome } from "~/lib/siteglue/marketing-chrome";
export function CTA() {
  const chrome = getMarketingChrome();
  const isSiteGlue = chrome.brandId === "siteglue";

  return (
    <section data-testid="section-cta" className="relative py-24 sm:py-32">
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-border to-transparent" />
        <div className="absolute bottom-1/3 left-1/2 -translate-x-1/2 w-[600px] h-[400px] rounded-full bg-primary/5 blur-[100px]" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight"
        >
          {isSiteGlue ? (
            <>Ready to put SiteGlue to work?</>
          ) : (
            <>
              Ready to put your
              <br />
              <span className="text-primary">team in the loop?</span>
            </>
          )}
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="mt-6 text-lg text-muted-foreground max-w-xl mx-auto leading-relaxed"
        >
          {isSiteGlue
            ? "Create an AI employee that works alongside your team while keeping a human in the loop."
            : "Join hundreds of businesses and organizations turning AI engagements into real human conversations."}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row"
        >
          {isSiteGlue ? (
            <>
              <PrimaryCTA location="final_cta" testId="button-cta-build-agent-free" />
              <BookDemoCTA location="final_cta" testId="button-cta-book-demo" />
            </>
          ) : (
            <BuildAgentForFreeButton
              testId="button-cta-build-agent-free"
              showArrow
              className="gap-2"
            />
          )}
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
          className="mt-8 flex items-center justify-center gap-6 text-sm text-muted-foreground flex-wrap"
        >
          <span>No Credit Card Required</span>
          <span className="hidden sm:inline text-border">|</span>
          <span>300+ EMR Integrations</span>
          <span className="hidden sm:inline text-border">|</span>
          <span>HIPAA Compliant</span>
        </motion.div>
      </div>
    </section>
  );
}
